import { withBusinessSelector } from '../../hooks/useBusinessSelector'

import { Home } from './Home'

const HomeWithBusinessSelector = withBusinessSelector(Home)
export default HomeWithBusinessSelector
